import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { IconHolder } from "../create_mission_components/components/SquareButtons";
import CaretIcon from "../../../../../../assets/images/researcher_app/dashboard/caret_up_white.svg"
// import PurpleUserPool from "../../../../../../assets/images/researcher_app/dashboard/user_pool_purple.png"
// import PurpleYourCommunity from "../../../../../../assets/images/researcher_app/dashboard/your_community_purple.png"
// import PurpleLiveFeedback from "../../../../../../assets/images/researcher_app/dashboard/live_feedback_purple.png"
// import PurpleSurvey from "../../../../../../assets/images/researcher_app/dashboard/survey_purple.png"

import UserPoolIcon from "../../../../../../assets/images/researcher_app/dashboard/tutorial_user_pool_icon.png"
import YourCommunityIcon from "../../../../../../assets/images/researcher_app/dashboard/tutorial_your_community_icon.png"
import LiveFeedbackIcon from "../../../../../../assets/images/researcher_app/dashboard/tutorial_live_feedback_icon.png"
import SurveyIcon from "../../../../../../assets/images/researcher_app/dashboard/tutorial_survey_icon.png"

import { SectionTitleRow, SectionTitle } from "../common_components/Layout";
import { TertiaryLink } from "../common_components/Buttons";



import { Card } from "../common_components/Layout";


function MissionTutorialCard(props) {
    const navigate = useNavigate();

    return (
        <div className="section">
            <SectionTitleRow>
                <SectionTitle title="Tutorial - How Does Despark Work?" />
            </SectionTitleRow>
            <div className="empty-mission-card-container">
                <div className="tutorial-section-container">
                    <div className="collapsible-container">
                        <a className="collapse-row-button" data-bs-toggle="collapse" href="#audience-collapse" role="button" aria-expanded="true" aria-controls="audience-collapse">
                            <TutorialCardTitle stepNumber={1} title="Select your Audience" />
                            <img className="caret-icon" src={CaretIcon} width={24} height={24} />
                        </a>
                        <div className="collapsible-tutorial-content collapse show" id="audience-collapse">
                            <div className="tutorial-content-container">
                                <UserPoolTutorialCard />
                                <YourCommunityTutorialCard />
                            </div>
                        </div>
                    </div>
                    <div className="collapsible-container">
                        <a className="collapse-row-button collapsed" data-bs-toggle="collapse" href="#format-collapse" role="button" aria-expanded="false" aria-controls="format-collapse">
                            <TutorialCardTitle stepNumber={2} title="Select your Research Format" />
                            <img className="caret-icon" src={CaretIcon} width={24} height={24} />
                        </a>
                        <div className="collapsible-tutorial-content collapse" id="format-collapse">
                            <div className="tutorial-content-container">
                                <LiveFeedbackTutorialCard />
                                <SurveyTutorialCard />
                            </div>
                        </div>
                    </div>
                    <div className="collapsible-container">
                        <a className="collapse-row-button collapsed" data-bs-toggle="collapse" href="#project-details-collapse" role="button" aria-expanded="false" aria-controls="project-details-collapse">
                            <TutorialCardTitle stepNumber={3} title="Set up Project Details" />
                            <img className="caret-icon" src={CaretIcon} width={24} height={24} />
                        </a>
                        <div className="collapsible-tutorial-content collapse" id="project-details-collapse">
                            <div className="tutorial-content-container">
                                <ProjectDetailsTutorialCard />
                            </div>
                        </div>
                    </div>
                    <div className="collapsible-container">
                        <a className="collapse-row-button collapsed" data-bs-toggle="collapse" href="#kickoff-collapse" role="button" aria-expanded="false" aria-controls="kickoff-collapse">
                            <TutorialCardTitle stepNumber={4} title="Kick off your research" />
                            <img className="caret-icon" src={CaretIcon} width={24} height={24} />
                        </a>
                        <div className="collapsible-tutorial-content collapse" id="kickoff-collapse">
                            <div className="tutorial-content-container justify-start">
                                <div className="get-started-today-card" onClick={() => navigate("/createmission/")}>
                                    <div className="cta-tutorial-text">
                                        Create a mission today!
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tutorial-link-to-guide">
                View the <a href="https://desparkwiki.notion.site/researcher-guide" target="_blank" rel="noopener noreferrer" className="light-gray-link">full researcher guide</a> for more information.
            </div>
        </div>
    )

}

function TutorialCardTitle(props) {
    return (
        <div className="collapsible-card-title"> <span className="tutorial-step-number">Step {props.stepNumber}: </span>{props.title} </div>
    )
}


function UserPoolTutorialCard(props) {

    return (
        <div className="square-button-tutorial">
            <IconHolder>
                <img src={UserPoolIcon} />
            </IconHolder>
            <div className="square-button-text-content">
                <div className="square-button-title">
                    Despark's User Pool
                </div>
                <div className="square-button-bullet-points">
                    <ul className="limited-padding-ul purple-check-bullets">
                        <li><span className="right-4-pix">Do research with our diverse group of users</span></li>
                        <li className="top-padding-li"><span className="right-4-pix">We handle payment, recording, scheduling, and other logistics</span></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

function YourCommunityTutorialCard(props) {

    return (
        <div className="square-button-tutorial">
            <IconHolder>
                <img src={YourCommunityIcon} />
            </IconHolder>
            <div className="square-button-text-content">
                <div className="square-button-title">
                    Your Community
                </div>
                <div className="square-button-bullet-points">
                    <ul className="limited-padding-ul purple-check-bullets">
                        <li><span className="right-4-pix">Drop a URL in your community channels</span></li>
                        <li className="top-padding-li"><span className="right-4-pix">Filter your users by on-chain activity</span></li>
                        <li className="top-padding-li"><span className="right-4-pix">(Optional) Offer users a reward for participating</span></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

function LiveFeedbackTutorialCard(props) {

    return (
        <div className="square-button-tutorial">
            <IconHolder>
                <img src={LiveFeedbackIcon} />
            </IconHolder>
            <div className="square-button-text-content">
                <div className="square-button-title">
                    Live Feedback Sessions
                </div>
                <div className="square-button-bullet-points">
                    <ul className="limited-padding-ul purple-check-bullets">
                        <li><span className="right-4-pix">1:1 interviews for any form of feedback</span></li>
                        <li className="top-padding-li"><span className="right-4-pix">We handle scheduling, recordings, and logistics, you run the session</span></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

function SurveyTutorialCard(props) {

    return (
        <div className="square-button-tutorial">
            <IconHolder>
                <img src={SurveyIcon} />
            </IconHolder>
            <div className="square-button-text-content">
                <div className="square-button-title">
                    Survey
                </div>
                <div className="square-button-bullet-points">
                    <ul className="limited-padding-ul purple-check-bullets">
                        <li><span className="right-4-pix">Launch surveys to quickly quantify user opinions</span></li>
                        <li className="top-padding-li"><span className="right-4-pix">Supports complex logic and a large variety of question formats</span></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

function ProjectDetailsTutorialCard(props) {

    return (
        <div className="details-tutorial-container">
            <SimpleDetailsStep stepNumber={1} text="Choose the number of responses you want" />
            <ComplicatedDetailsStep stepNumber={2} text="Define your target audience through both audience requirements and screener questions">
                <div className="complicated-details-step-container">
                    <div className="complicated-details-subcontainer">
                        <div className="complicated-details-substep">
                            <div className="complicated-details-substep-title">
                                Audience Requirements
                            </div>
                            <div className="standard-white-text">
                                Define your audience by
                                <ul>
                                    <li>Geography</li>
                                    <li>Demographics</li>
                                    <li>Crypto Usage</li>
                                    <li>On-chain Activity</li>
                                </ul>
                            </div>
                        </div>
                        <div className="complicated-details-substep">
                            <div className="complicated-details-substep-title">
                                Screener
                            </div>
                            <div className="standard-white-text">
                                Create a short screener survey to refine your audience
                            </div>
                        </div>
                    </div>
                </div>
            </ComplicatedDetailsStep>
            <SimpleDetailsStep stepNumber={3} text="Enter your availability for sessions or create your survey" />
            <SimpleDetailsStep stepNumber={4} text="Enter your payment details (you aren't charged until the project is complete)" />
        </div>
    )
}

function SimpleDetailsStep(props) {
    return (
        <div className="simple-details-step">
            <div className="simple-details-step-number-bubble">
                <div className="simple-details-step-number">{props.stepNumber}</div>
            </div>
            <div className="simple-details-step-text">
                {props.text}
            </div>
        </div>
    )
}

function ComplicatedDetailsStep(props) {

    function navigateToFAQ() {
        window.open("https://desparkwiki.notion.site/How-do-I-set-up-a-Mission-as-a-researcher-3ec323aae0c746e89b2f362c44c726b2", "_blank")
    }

    return (
        <div className="simple-details-step complicated">
            <div className="complicated-details-title-container">
                <div className="simple-details-step-number-bubble">
                    <div className="simple-details-step-number">{props.stepNumber}</div>
                </div>
                <div className="complicated-details-text-div">
                    <div className="simple-details-step-text">
                        {props.text}
                    </div>
                    <div className="complicated-details-faq-link-div">
                        <div className="complicated-details-link-explainer-text">
                            Need Help?
                        </div>
                        <TertiaryLink text="Visit our FAQ" onClick={() => navigateToFAQ()} />
                    </div>
                </div>
            </div>
            {props.children}
        </div>
    )
}


export { MissionTutorialCard }